// frontend/src/components/landing/useReveal.js
import { useEffect, useRef, useState } from 'react';

// True once the element has scrolled into view; stays true. Without IntersectionObserver
// (older browsers, tests) the content shows at once.
const useReveal = () => {
    const ref = useRef(null);
    const [shown, setShown] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return undefined;
        if (typeof IntersectionObserver === 'undefined') {
            setShown(true);
            return undefined;
        }
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setShown(true);
                    observer.disconnect();
                }
            },
            { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return [ref, shown];
};

export default useReveal;
